import { render, staticRenderFns } from "./childSongs.vue?vue&type=template&id=23eb235c&scoped=true"
import script from "./childSongs.vue?vue&type=script&lang=js"
export * from "./childSongs.vue?vue&type=script&lang=js"
import style0 from "./childSongs.vue?vue&type=style&index=0&id=23eb235c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eb235c",
  null
  
)

export default component.exports